module.exports = __webpack_public_path__ + "static/media/illustration-intro.526544ae.png";